import { BASE_LISTING_URL } from '@config/index';

import { sdkRequest } from '../sdk';
import { RentennialsCities, RentennialsCitiesSchema } from '../types/citiesSchema';

export const getCities = async (): Promise<RentennialsCities> => {
  const response = await sdkRequest('cities', undefined, BASE_LISTING_URL);
  return RentennialsCitiesSchema.parse(response);
};
